import { useCallback, useState } from 'react';

import { useUpdateSwingName } from '@queries';

export const useSwingNameUpdateModal = (activityId: number) => {
    const { mutate: updateSwingName } = useUpdateSwingName(activityId);

    const [swingToNameUUID, setSwingToNameUUID] = useState<string | null>();

    const closeNameUpdateModal = useCallback(() => setSwingToNameUUID(null), []);

    const openNameUpdateModal = useCallback(
        (uuid: string, favorite: boolean) => {
            if (favorite) return updateSwingName({ uuid, name: null });
            else setSwingToNameUUID(uuid);
        },
        [updateSwingName],
    );

    const submitNameUpdateModal = useCallback(
        (swingName: string) => {
            if (!swingToNameUUID) {
                return;
            }
            updateSwingName({ uuid: swingToNameUUID, name: swingName }, { onSuccess: closeNameUpdateModal });
        },
        [swingToNameUUID, updateSwingName, closeNameUpdateModal],
    );

    return {
        open: openNameUpdateModal,
        close: closeNameUpdateModal,
        submit: submitNameUpdateModal,
        isOpen: !!swingToNameUUID,
        swingUuid: swingToNameUUID,
    };
};
